export const STORAGE_URL = 'https://storage.googleapis.com/mullerwindsports.appspot.com/';
export const PAYMENTS_URL = 'https://payments.mullerwindsports.com/';
export const LOGO_URL = 'muller-logo.webp';
export const LOGO_CUT_URL = 'mws.png';
